import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client  from '../../graphql/client';
import { GET_USER_PROFILE_DATA } from '../../graphql/userProfile';
import { UserProfile, Address, Order, PaymentDetails } from '../../interfaces/user';


// 1. Define types
interface UserProfileState {
  user: UserProfile | null;
  addresses: Address[];
  getOrders: Order[];
  getTransactions: PaymentDetails[];
  loading: boolean;
  error: string | null;
}

// 2. Type the async thunk
export const fetchUserProfileData = createAsyncThunk<
  {
    user: UserProfile;
    addresses: Address[];
    getOrders: Order[];
    getTransactions: PaymentDetails[];
  },
  string
>(
  'userProfile/fetch',
  async (userId) => {
    const { data } = await client.query({
      query: GET_USER_PROFILE_DATA,
      variables: { userId },
      fetchPolicy: 'no-cache',
    });
    return data;
  }
);

// 3. Provide initial state
const initialState: UserProfileState = {
  user: null,
  addresses: [],
  getOrders: [],
  getTransactions: [],
  loading: false,
  error: null,
};


const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfileData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserProfileData.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.addresses = action.payload.addresses;
        state.getOrders = action.payload.getOrders;
        state.getTransactions = action.payload.getTransactions;
      })
      .addCase(fetchUserProfileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Something went wrong';
      });
  },
});

export default userProfileSlice.reducer;
